import React, { useCallback } from "react";

function CountrySelect({ id, name, enabled, onToggle }) {
  const inputId = `country-select-${id}`;

  const handleChange = useCallback(() => {
    onToggle(id);
  }, [id, onToggle]);

  return (
    <div className="custom-control custom-switch">
      <input
        type="checkbox"
        className="custom-control-input"
        name="partner[country_ids][]"
        id={inputId}
        value={id}
        checked={enabled}
        onChange={handleChange}
      />
      <label className="custom-control-label" htmlFor={inputId}>
        {name}
      </label>
    </div>
  );
}

export default CountrySelect;
